<template>
  <div>
    <span>{{ job.lead_type || "--" }}</span>
    <i class="fas fa-edit ml-2 link" @click="toggleJobLeadModal"></i>
    <JobLeadModal
      v-if="jobLeadModal"
      :job="job"
      table-mode
      @hide-modal="toggleJobLeadModal"
      @success-update="refreshTable"
    />
  </div>
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";

import JobLeadModal from "./JobLeadModal.vue";

export default {
  components: {
    JobLeadModal
  },
  props: {
    job: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      jobLeadModal: false
    };
  },
  methods: {
    toggleJobLeadModal() {
      this.jobLeadModal = !this.jobLeadModal;
    },
    refreshTable() {
      EventBus.$emit("refresh-datatable");
    }
  }
};
</script>

<style lang="scss" scoped></style>
